const { getCurrentEnvConfig } = require('../../config/env');

const EnvHost = {
  'aubusa.dev.autobestdevops.com': 'dev',
  'aubusa.test.autobestdevops.com': 'test',
  'aubusa.uat.autobestdevops.com': 'uat',
  'aubusa.prod.autobestdevops.com': 'prod'
};

export default function getRunEnv() {
  if (process.env.NODE_ENV === 'development') {
    return process.env;
  }

  return getCurrentEnvConfig(EnvHost[window.location.hostname.toLowerCase()]);
}
